
export enum CrosshairMode {
    polygon = 'polygon',
    polyline = 'polyline',
    spot = 'spot'
}
